<script setup>
import GoogleMerchantForm from '@frontJs/components/forms/projectManagement/customers/externalServices/GoogleMerchantForm.vue';
import ProjectManagementLayout from '@frontJs/layouts/ProjectManagementLayout.vue';
import { Head } from '@inertiajs/vue3';
import PageTitle from '@js/components/titles/PageTitle.vue';

const { tenant, externalService, eCommerceStores } = defineProps({
    tenant: {
        type: Object,
        required: true,
    },
    externalService: {
        type: Object,
        required: true,
    },
    eCommerceStores: {
        type: Array,
        required: true,
    },
});

defineOptions({ layout: ProjectManagementLayout });
</script>

<template>
    <Head>
        <title>
            Google Merchant - Services externes - Clients - Gestion de projet -
            Datakepler
        </title>
    </Head>

    <PageTitle :tenant-name="tenant.name">
        Gestion de projet - Clients - Services externes - Google Merchant
    </PageTitle>

    <GoogleMerchantForm
        :tenant="tenant"
        :external-service="externalService"
        :e-commerce-stores="eCommerceStores"
    />
</template>
